import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { COMMIT_HASH, IS_PROD, IS_STAGING } from './config'

Sentry.init({
  dsn: 'https://7c57b767271324590198de1443741d87@o4507653178064896.ingest.us.sentry.io/4507653187108864',
  environment: IS_PROD ? 'prod' : IS_STAGING ? 'staging' : 'dev',
  release: COMMIT_HASH,
  dist: COMMIT_HASH,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      // Mask all text input by default
      maskAllText: true,
      // Block specific pages from being recorded
      blockAllMedia: true,
    }),
    Sentry.browserTracingIntegration(),
  ],

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ['api.polimorphic.com', /^\/api\//],

  // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
  tracesSampleRate: 1.0,

  // Session Replay
  replaysSessionSampleRate: IS_PROD ? 0.1 : 0.0,
  replaysOnErrorSampleRate: IS_PROD ? 1.0 : 0.0,
})
